import qs from 'qs';
import { useQuery } from '@tanstack/react-query';

import { useApi, useAuth } from '../../hooks';
import { FeedbackType, UserFeedbackSurvey } from '../../models/userFeedback';
import { useParams } from 'react-router-dom';

type Props = {
  survey_type?: FeedbackType;
  user_block_id?: string;
  order_by?: 'asc' | 'desc';
  enabled?: boolean;
};

export const useUserFeedbackSurvey = ({
  survey_type,
  user_block_id,
  order_by,
  enabled = true,
}: Props = {}) => {
  const { patient: userId } = useParams();

  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const queryStr = qs.stringify({ survey_type, user_block_id, order_by });

  const fetchUserFeedback = async () => {
    const requestObj = {
      route: `/private/feedback/user-survey${queryStr ? `?${queryStr}` : ''}`,
      token: userToken,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Coach-Override': userId ?? '',
      },
    };

    return await api(requestObj);
  };

  const { data, isLoading, isError } = useQuery<UserFeedbackSurvey[], Error>({
    queryKey: [
      'user-feedback',
      userToken,
      userId,
      user_block_id,
      survey_type,
      order_by,
    ],
    queryFn: () => fetchUserFeedback(),
    enabled: enabled && isAuthenticated && !loading && !!userToken && !!userId,
    refetchOnWindowFocus: false,
  });

  return { userFeedbackSurveyData: data, isLoading, isError };
};
